var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2141_10430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.0043 9.25223C8.00309 8.21239 8.76089 7.11548 10.2446 6.25886C12.9551 4.69402 17.0551 4.52404 19.4024 5.87927C20.4545 6.48668 20.9742 7.29741 20.9852 8.14802H20.9857V9.43889V9.49647V10.7873L20.984 10.7874C20.9843 10.796 20.9834 10.8047 20.9835 10.8133L20.9857 10.8131V12.0626V12.1616V13.4111L20.984 13.4112C20.9843 13.4198 20.9834 13.4285 20.9835 13.437L20.9857 13.4369V14.7853L20.984 14.7855C20.9846 14.8061 20.9829 14.827 20.9828 14.8477L20.9857 14.8475V16.1959L20.984 16.196C21.0133 17.2524 20.2555 18.3736 18.7449 19.2456C16.0345 20.8104 11.9344 20.9804 9.58709 19.6251C8.49861 18.9967 7.98539 18.1501 8.01057 17.2673L8.01151 15.951C8.011 15.9196 8.00971 15.8882 8.01057 15.8568L8.01117 14.5405C8.01117 14.5211 8.01005 14.5019 8.01057 14.4826L8.01014 13.1663L8.01109 11.9167C8.01109 11.8974 8.00997 11.8781 8.01048 11.8587L8.00249 10.5685H8.00232V9.25232L8.0043 9.25223Z",
    fill: "#DCA700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58705 14.2165C11.9343 15.5718 16.0344 15.4018 18.7449 13.837C20.2431 12.972 20.9998 11.862 20.9835 10.8132L20.9856 10.813V12.1614L20.984 12.1615C21.0133 13.218 20.2554 14.3391 18.7449 15.2111C16.0344 16.7759 11.9343 16.9459 9.58705 15.5907C8.49857 14.9622 7.98535 14.1157 8.01053 13.2328L8.01113 11.9169C8.00975 12.7786 8.52254 13.6019 9.58705 14.2165Z",
    fill: "#CC8200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58705 16.8405C11.9343 18.1957 16.0344 18.0257 18.7449 16.4609C20.2431 15.5959 20.9998 14.486 20.9835 13.4372L20.9856 13.437V14.7855L20.984 14.7856C21.0133 15.8421 20.2554 16.9632 18.7449 17.8353C16.0344 19.4001 11.9343 19.5701 9.58705 18.2149C8.49857 17.5864 7.98535 16.7398 8.01053 15.8571L8.01113 14.5411C8.00975 15.4027 8.52254 16.2259 9.58705 16.8405Z",
    fill: "#CC8200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2446 6.25886C7.53416 7.82369 7.23982 10.1909 9.58712 11.5462C11.9344 12.9014 16.0346 12.7314 18.745 11.1666C21.4553 9.60174 21.7498 7.23451 19.4025 5.87927C17.0552 4.52404 12.9551 4.69402 10.2446 6.25886Z",
    fill: "#DCA700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9853 8.14795C20.9989 9.19527 20.2406 10.303 18.745 11.1665C16.0345 12.7313 11.9344 12.9013 9.58713 11.5461C8.52477 10.9327 8.00536 10.1119 8.00433 9.25216L8.00244 9.25233V10.5686C8.00244 10.5686 8.04275 12.0127 9.58713 12.9256C11.9203 14.305 16.0345 14.1109 18.745 12.5461C20.2554 11.674 21.0133 10.5528 20.984 9.49639L20.9857 9.49631V8.14795H20.9853Z",
    fill: "#CC8200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9995 6.69452C8.77042 7.98144 8.52833 9.92826 10.4587 11.0428C12.3892 12.1573 15.7611 12.0175 17.9901 10.7306C20.2192 9.44366 20.4613 7.49692 18.5309 6.38231C16.6004 5.26779 13.2285 5.40752 10.9995 6.69452Z",
    fill: "#FFD800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5988 8.13315C11.2525 9.12916 12.8544 9.89942 13.5561 10.157C14.4675 10.4915 15.474 10.5678 16.3772 10.1562L16.9887 10.5092L17.5651 10.1765L16.9519 9.82242C17.1894 9.64874 17.3643 9.46338 17.4751 9.26606L16.4904 8.69759C16.3647 8.9224 16.2023 9.11481 16.0032 9.27474L13.5208 7.84148C13.7859 7.73904 14.0795 7.68232 14.3582 7.63454L13.7502 6.92676C13.299 7.00238 12.9008 7.12166 12.554 7.28323L11.9868 6.95572L11.4104 7.28847L11.9902 7.6232C11.7936 7.78149 11.6621 7.95122 11.5988 8.13315C11.6621 7.95122 11.5075 8.39577 11.5988 8.13315ZM13.0015 8.20731L15.3555 9.56641C14.8288 9.65751 12.6366 9.03807 13.0015 8.20731Z",
    fill: "#DCA700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 16.4649V22.1394L14.6667 39.0355L0 30.5779V24.9327L29.3333 7.99707L44 16.4649Z",
    fill: "#007A6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0001 16.4648V22.1393L14.6667 39.0355V33.4104L44.0001 16.4648Z",
    fill: "#009F5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6661 34.5377L44 17.5957V18.7266L14.6661 35.6739L0.020752 27.2183V26.0874L14.6661 34.5377Z",
    fill: "#00917F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6716 36.7902L44 19.8574V20.9883L14.6716 37.9262L0 29.4669V28.3372L14.6716 36.7902Z",
    fill: "#00917F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 17.5957V18.7266L14.6661 35.6739V34.5377L44 17.5957Z",
    fill: "#00AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 19.8574V20.9883L14.6716 37.9262V36.7902L44 19.8574Z",
    fill: "#00AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37238 28.0381L0 24.9327L29.3333 7.99707L44 16.4649L14.6667 33.4105L5.37238 28.0381Z",
    fill: "#00C169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.80591 24.9368L14.6824 31.7803L41.2066 16.4651L29.3349 9.6167L2.80591 24.9368Z",
    fill: "#FFE6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.438 16.4649L29.3447 11.2148L5.62866 24.9366L14.6978 30.1613L38.438 16.4649Z",
    fill: "#00AC65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 13.6426L34.2222 22.1137V27.7717L24.4647 33.389V27.7505L9.78601 19.283L19.5556 13.6426Z",
    fill: "#E5AC91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 13.6426L34.2222 22.1137L24.4647 27.7505L9.78601 19.283L19.5556 13.6426Z",
    fill: "#FFD6A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4647 27.7501V33.3886L34.2221 27.7713V22.1133L24.4647 27.7501Z",
    fill: "#E5AC91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0968 18.5261L18.2571 14.3921L32.9192 22.8625L25.7706 26.9941L11.0968 18.5261Z",
    fill: "#FFE6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9191 22.8623V28.522L25.77 32.6398L25.7705 26.9938L32.9191 22.8623Z",
    fill: "#FFCBA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2235 12.013C29.0629 12.4976 30.3325 12.5502 31.0595 12.1305C31.7863 11.7109 31.6952 10.9778 30.8559 10.4932C30.0165 10.0086 28.7469 9.95596 28.0199 10.3756C27.293 10.7953 27.3842 11.5284 28.2235 12.013Z",
    fill: "#FFE6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0514 16.2423C29.5376 16.523 30.2729 16.5535 30.694 16.3104C31.115 16.0674 31.0622 15.6427 30.5761 15.3621C30.0899 15.0814 29.3545 15.0509 28.9335 15.294C28.5125 15.537 28.5653 15.9616 29.0514 16.2423Z",
    fill: "#FFE6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7711 25.6222C13.2572 25.9029 13.9926 25.9334 14.4136 25.6903C14.8346 25.4472 14.7818 25.0226 14.2957 24.742C13.8095 24.4613 13.0742 24.4308 12.6532 24.6739C12.2321 24.9169 12.2849 25.3415 12.7711 25.6222Z",
    fill: "#FFE6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41188 25.7795C5.25123 26.2641 6.52087 26.3167 7.24781 25.897C7.97467 25.4774 7.88349 24.7443 7.04423 24.2598C6.20488 23.7752 4.93524 23.7226 4.20829 24.1422C3.48135 24.5618 3.57253 25.2949 4.41188 25.7795Z",
    fill: "#FFE6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0346 17.111C37.8739 17.5956 39.1435 17.6482 39.8705 17.2286C40.5974 16.8089 40.5063 16.0758 39.6669 15.5913C38.8276 15.1067 37.5579 15.0541 36.831 15.4737C36.104 15.8934 36.1952 16.6264 37.0346 17.111Z",
    fill: "#FFE6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1786 30.8815C14.0179 31.3661 15.2876 31.4187 16.0145 30.9991C16.7414 30.5795 16.6503 29.8464 15.8109 29.3618C14.9716 28.8772 13.7019 28.8246 12.975 29.2442C12.2481 29.6639 12.3392 30.3969 13.1786 30.8815Z",
    fill: "#FFE6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8139 23.02L17.9353 16.167L16.6661 16.8994L28.5448 23.767L29.8139 23.02Z",
    fill: "#E6C190"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.847 23.6979L16.7749 18.4585L15.5131 19.191L24.5851 24.4214L25.847 23.6979Z",
    fill: "#E6C190"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 8,
    r: 6,
    fill: "#D93B0C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 7,
    width: 2,
    height: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 4,
    width: 2,
    height: 2,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2141_10430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollect);
export default __webpack_public_path__ + "static/media/icon_collect.2e152df3160c4b591a15d09e71ab3941.svg";
export { ForwardRef as ReactComponent };